export const isFromAkamaiImageManager = url => /trvl-media/.test(url) || /media.int/.test(url);